import { render, staticRenderFns } from "./secondCaseRow.vue?vue&type=template&id=0a907c9e&"
import script from "./secondCaseRow.vue?vue&type=script&lang=js&"
export * from "./secondCaseRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports